module.exports = __webpack_public_path__ + "media/1tentative.4dd441c9.mp3";